// extracted by mini-css-extract-plugin
export default {"special-offer-card":"YZR_6FP4x3MB0Qz","special-offer-card-img":"Q5urlIxMYi_4z8f"};